module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAoCAMAAACsAtiWAAAARVBMVEUAAABweINvd4NudoNtdYJwdYVud4Nvd4JweIBud4JtdoJudoNud4NudoJwdoJvdoNtdIFudoNud4JvdoNwdoJwcIBvd4MaJAZlAAAAFnRSTlMAQL+APzDwXyCwcKCQ4E7PiOfQr3AQq/46HgAAAKNJREFUOMvtkkkOwyAQBJnBLA7Yztr/f2qICCBCwMf4kDogpC4xmhaiZZKMzYhCG0doEOv5pISBHMUvqFZUHbeK4o+4VRw4xn1FIxxjBYdTHlOmpzhkTEchTsxWHG7p855iAEdjZUVgkXY8yFwB3CgrK2dKL9ZrwCfFd9pdNWwapOiNrZf2oL1e5F/5reKCwti45YIlXjSUUAtGxNfoC+Ze/sYTe08UqK0KBMYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_company.png
// module id = KRN5
// module chunks = 21